enum Session {
  LoggedOut,
  Client,
  RelationshipManager
}

export default Session;
